"use client";

import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Form() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [FName, setFName] = useState("");
  const [cell, setCell] = useState("");
  const [message, setMessage] = useState("");
  const [pacakge, setPackage] = useState("");

  function sendMail() {
    console.log("Sending Email");

    if (FName && email && cell && pacakge) {
      localStorage.setItem("name", FName);
      localStorage.setItem("email", email);
      localStorage.setItem("cell", cell);
      localStorage.setItem("message", message);
      localStorage.setItem("pacakge", pacakge);

      // Prepare the FormData to include attachments
      const formData = new FormData();
      formData.append(
        "message",
        `Name : ${FName} <br/> Phone: ${cell} <br/> Email: ${email} <br/> Message: ${message} <br/> Package: ${pacakge}`
      );
      formData.append("subject", "Website Quote Request");
      formData.append("to", "info@hemsida.co.za");

      // Attach all files from a multiple file input
      const fileInput = document.getElementById("attachment"); // assume there’s an <input type="file" id="attachment" multiple>
      if (fileInput && fileInput.files.length > 0) {
        for (let i = 0; i < fileInput.files.length; i++) {
          formData.append("attachments[]", fileInput.files[i]); // Use "attachments[]" to indicate multiple files
        }
      }

      axios
        .post("https://hemsidaemail.vercel.app/send_Resend", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      return navigate("/ThankYou");
    }

    return alert("Fill in all fields to continue");
  }

  const handlePackageChange = (e) => {
    setPackage(e.target.value);
  };

  return (
    <>
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-9 col-lg-10">
            <div className="bg-light p-4 rounded shadow">
              <h2 className="h5 fw-bold mb-3">
                Complete the form and we will get back to you ASAP!
              </h2>
              <form>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Your full name"
                    value={FName}
                    onChange={(e) => setFName(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="cell" className="form-label">
                    Cell Number
                  </label>
                  <input
                    type="tel"
                    id="cell"
                    className="form-control"
                    placeholder="Your cell number"
                    value={cell}
                    onChange={(e) => setCell(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Message
                  </label>
                  <textarea
                    id="message"
                    rows="3"
                    className="form-control"
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label">Choose a Package:</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="basic"
                      name="package"
                      value="Basic Special"
                      checked={pacakge === "Basic Special"}
                      onChange={handlePackageChange}
                    />
                    <label className="form-check-label" for="basic">
                      Basic
                      <div
                        className="badge bg-primary text-white mt-2"
                        style={{ marginLeft: "6px" }}
                      >
                        Basic Special
                      </div>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="professional"
                      name="package"
                      checked={pacakge === "Professional"}
                      value="Professional"
                      onChange={handlePackageChange}
                    />
                    <label className="form-check-label" htmlFor="professional">
                      Professional
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="advance"
                      name="package"
                      value="Advance"
                      checked={pacakge === "Advance"}
                      onChange={handlePackageChange}
                    />
                    <label className="form-check-label" htmlFor="advance">
                      Advance
                    </label>
                  </div>
                  {/* <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="custom"
                      name="package"
                      value="Custom"
                      onChange=""
                    />
                    <label className="form-check-label" htmlFor="custom">
                      Custom
                    </label>
                  </div> */}
                </div>

                <div className="text-end">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled=""
                    onClick={() => sendMail()}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
